import { AtsCvBulkUploadStatusesEnum } from 'generated/resources/graphql'

import { acceptedContentTypes } from 'modules/core/lib/fileFormats'

export interface UploadCvsFormValues {
  accessId: number
  atsJobPostingId?: number | undefined
  atsApplicationPhaseId?: number | undefined
  atsCandidateSourceId: number
  companyId: number
  files: File[]
}

export const CV_BULK_UPLOAD_ACCEPTED_CONTENT_TYPES = () =>
  acceptedContentTypes([
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ])

export const CV_BULK_UPLOAD_LIMIT = 20

export const isCvBulkUploadCompleted = (status: AtsCvBulkUploadStatusesEnum) => {
  return ['completed', 'cancelled', 'archived'].includes(status)
}
